import { render, staticRenderFns } from "./ThemeColor.vue?vue&type=template&id=70538eb4&scoped=true&"
import script from "./ThemeColor.vue?vue&type=script&lang=js&"
export * from "./ThemeColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70538eb4",
  null
  
)

export default component.exports